export default __webpack_public_path__ + "static/underline-16-mobile-41f8e7c26b5b668970a373441eb35f7f.svg";